import { render, staticRenderFns } from "./systemNotification.vue?vue&type=template&id=e487e450&"
import script from "./systemNotification.vue?vue&type=script&lang=js&"
export * from "./systemNotification.vue?vue&type=script&lang=js&"
import style0 from "./systemNotification.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports